// Foundations
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-arrow-link',
  templateUrl: './arrow-link.component.html',
  styleUrls: ['./arrow-link.component.scss']
})
export class ArrowLinkComponent implements OnInit {

  @Input() text = 'Arrow Link Text';
  @Input() useLato = false;
  @Output() handleClick = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  onClick(): void {
    this.handleClick.emit();
  }

}
